import { render, staticRenderFns } from "./UCRInfo.vue?vue&type=template&id=649919ad&scoped=true"
import script from "./UCRInfo.vue?vue&type=script&lang=js"
export * from "./UCRInfo.vue?vue&type=script&lang=js"
import style0 from "./UCRInfo.vue?vue&type=style&index=0&id=649919ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649919ad",
  null
  
)

export default component.exports